$(document).ready(function () {
  const yearSelector = $("select#GetYear");
  const makeSelector = $("select#GetMake");
  const modelSelector = $("select#GetModel");
  const yearURL =
    "https://bimmerplug.rockethost.io/store-frontend/get_year.php";
  const makeURL =
    "https://bimmerplug.rockethost.io/store-frontend/get_make.php";
  const modelURL =
    "https://bimmerplug.rockethost.io/store-frontend/get_model.php";
  const collURL =
    "https://bimmerplug.rockethost.io/store-frontend/get_coll.php";

  $.get(yearURL, {}).done(function (data) {
    yearSelector.append(data);
  });

  yearSelector.on("change", function () {
    makeSelector.empty();
    makeSelector.removeClass("pointer-non");
    $.get(makeURL, { year: yearSelector.val() }).done(function (data) {
      makeSelector.append(data);
    });
  });

  makeSelector.on("change", function () {
    modelSelector.empty();
    modelSelector.removeClass("pointer-non");
    $.get(modelURL, {
      year: yearSelector.val(),
      make: makeSelector.val(),
    }).done(function (data) {
      modelSelector.append(data);
    });
  });

  modelSelector.on("change", function () {
    $("[data-redirect]").attr("href", "");
    $.get(collURL, {
      year: yearSelector.val(),
      make: makeSelector.val(),
      model: modelSelector.val(),
    }).done(function (data) {
      $("[data-redirect]").removeClass("disabled");
      $("[data-redirect]").attr("href", data);
    });
  });
});
